class SoundPool {
  constructor(maxSize) {
    this.maxSize = maxSize;
    this.pool = [];
    this.currSound = 0;
  }

	init (object) {
		if (object === "click") {
			for (let i = 0; i < this.maxSize; i++) {

				this.sound = new Audio("game/handlers/sounds/click2.mp3");
        this.defaultVolume = 0.12;
				this.sound.volume = this.defaultVolume;
				this.sound.load();
				this.pool[i] = this.sound;
			}
		}

    if (object === "cannon") {
			for (let i = 0; i < this.maxSize; i++) {

				this.sound = new Audio("game/handlers/sounds/cannon.mp3");
        this.defaultVolume = 0.06;
				this.sound.volume = this.defaultVolume;
				this.sound.load();
				this.pool[i] = this.sound;
			}
		}

    if (object === "splash") {
			for (let i = 0; i < this.maxSize; i++) {

				this.sound = new Audio("game/handlers/sounds/splash.mp3");
        this.defaultVolume = 0.06;
				this.sound.volume = this.defaultVolume;
				this.sound.load();
				this.pool[i] = this.sound;
			}
		}

	}

	get () {
		if(this.pool[this.currSound].currentTime === 0 || this.pool[this.currSound].ended) {
			this.pool[this.currSound].play();
		}
		this.currSound = (this.currSound + 1) % this.maxSize;
	}

  mute () {
    this.pool.forEach(sound => {
      sound.volume = 0;
    });
  }

  unmute () {
    this.pool.forEach(sound => {
      sound.volume = this.defaultVolume;
    });
  }
}

class GameAudio {
  constructor() {

  }

  init () {
		this.click = new SoundPool(20);
		this.click.init("click");
    this.cannon = new SoundPool(20);
		this.cannon.init("cannon");
    this.splash = new SoundPool(20);
		this.splash.init("splash");
		this.backgroundAudio = new Audio("game/handlers/sounds/background_music.mp3");
		this.backgroundAudio.loop = true;
    this.defaultVolume = 0.25;
    this.backgroundAudio.volume = this.defaultVolume;
		this.backgroundAudio.load();
		this.checkAudio = window.setInterval(() => this.checkReadyState(),1000);
	}

  checkReadyState () {
  	if (this.backgroundAudio.readyState === 4) {
  		window.clearInterval(this.checkAudio);
  		this.start();
  	}
  }

  start () {
    this.backgroundAudio.play();
  }

  unmute () {
    this.backgroundAudio.volume = this.defaultVolume;
    this.click.unmute();
    this.cannon.unmute();
    this.splash.unmute();
  }

  mute () {
    this.backgroundAudio.volume = 0;
    this.click.mute();
    this.cannon.mute();
    this.splash.mute();
  }
}

module.exports = GameAudio;



/*****************
 ** WEBPACK FOOTER
 ** ./game/handlers/audio.js
 ** module id = 16
 ** module chunks = 0
 **/